module.exports = __webpack_public_path__ + "552a870b8d0ff0782265b123c624e830.svg";